export default __webpack_public_path__ + "static/GmarketSansBold-03ceab7804dad3e86672fde35c76524e.otf";